<ng-content select="fui-tag"></ng-content>
